@if (formGroup) {
<div
  class="axis-form-group"
  id="axis-aug-form-{{id}}"
  [formGroup]="formGroup"
  [class.hidden]="!status.display"
  [class.has-axis-required]="uiStructure.required && thisField?.untouched && thisField?.value?.length < 1"
  [class.has-axis-error]="thisField?.invalid && (thisField?.touched || (errorMessages.getTriedToSubmit(uiStructure.AUGinstance) ? setAriaDescribedby() : ''))"
  [ngClass]="componentInfo.className"
>

  @if (uiStructure.label) {
  <label
    class="axis-control-label"
    id="{{uiStructure.labelId ? uiStructure.labelId : id + '-label'}}"
  >
    @if (uiStructure.prefix) {
    <span>{{uiStructure.prefix}}</span>
    }
    {{uiStructure.label}}{{formService.LabelSeparator}}<span *ngIf="uiStructure.required" class="axis-required-indicator">*</span>
    @if (uiStructure.labelMenu) {
    @for (item of uiStructure.labelMenu; track item) {
    <label-menu
      [item]="item"
      (labelMenuIconEvent)="labelMenuIconEvent($event)"
    ></label-menu>
    }
    }
  </label>
  }
  @if (uiStructure.addOn) {
  <div
    class="axis-input-group"
    [ngClass]="uiStructure.addOn.noSeparator ? 'axis-input-group-secondary': ''"
  >
    @if (uiStructure.addOn.static) {
    @if (uiStructure.addOn.static.placement==='left') {
    <span
      class="axis-input-group-addon"
      [innerHTML]="uiStructure.addOn.static.text"
    ></span>
    <ng-container *ngTemplateOutlet="textAreaTemplate">
    </ng-container>
    } @else {
    <ng-container *ngTemplateOutlet="textAreaTemplate">
    </ng-container>
    <span
      class="axis-input-group-addon"
      [innerHTML]="uiStructure.addOn.static.text"
    ></span>
    }
    }
    @if (uiStructure.addOn.clickable) {
    <ng-container *ngTemplateOutlet="textAreaTemplate">
    </ng-container>
    @if (uiStructure.addOn.clickable.kind==='icon') {
    <span class="axis-input-group-addon _cursor-pointer">
      <button
        axis-button
        class="kind-icon"
        (click)="addOnIconClick($event);"
      >
        <axis-icon [icon]="uiStructure.addOn.clickable.icon">
        </axis-icon>
      </button>
    </span>
    } @else {
    <span class="axis-input-group-btn">
      <button
        axis-button
        class="kind-icon"
        [attr.disabled]="uiStructure.addOn.clickable.disabled"
        (click)="addOnIconClick($event);"
      >
        <axis-icon [icon]="uiStructure.addOn.clickable.icon">
        </axis-icon>
      </button>
    </span>
    }
    }
  </div>
  } @else {
  <textarea
    formControlName="{{uiStructure['name']}}"
    [attr.id]="id"
    [attr.aria-label]="uiStructure.ariaLabel"
    [attr.aria-labelledby]="uiStructure.ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    [attr.readonly]="uiStructure.readonly ? 'readonly' : null"
    [attr.viewonly]="uiStructure.viewonly ? 'viewonly' : null"
    (change)="onEvent($event)"
    (onClear)="statusChangeEventEmit($event)"
    (keyup)="onEvent($event)"
    (blur)="statusChangeEventEmit($event)"
    [detectChange]="(uiStructure.detectChange === false || uiStructure.detectChange === 'false') ? false: true"
    [placeholder]="uiStructure.placeholder ? uiStructure.placeholder : ''"
    [minlength]="uiStructure.minLength"
    [maxlength]="uiStructure.maxLength"
    [pattern]="uiStructure.pattern"
    [attr.title]="uiStructure['title']"
    [attr.disabled]="uiStructure.disabled ? 'disabled' : null"
    [rows]="uiStructure.rows"
    #thisElement
    axis-input-clear
    axis-autosize
    [ngClass]="uiStructure.componentHostClasses"
    class="axis-form-control"
  >
    </textarea>
  }
  <ng-template #textAreaTemplate>
    <textarea
      formControlName="{{uiStructure['name']}}"
      [attr.id]="id"
      [attr.aria-label]="uiStructure.ariaLabel"
      [attr.aria-labelledby]="uiStructure.ariaLabelledby"
      [attr.aria-describedby]="ariaDescribedby"
      [attr.readonly]="uiStructure.readonly ? 'readonly' : null"
      [attr.viewonly]="uiStructure.viewonly ? 'viewonly' : null"
      (change)="onEvent($event)"
      (onClear)="statusChangeEventEmit($event)"
      (keyup)="onEvent($event)"
      (blur)="statusChangeEventEmit($event)"
      [detectChange]="(uiStructure.detectChange === false || uiStructure.detectChange === 'false') ? false: true"
      [placeholder]="uiStructure.placeholder ? uiStructure.placeholder : ''"
      [minlength]="uiStructure.minLength"
      [maxlength]="uiStructure.maxLength"
      [pattern]="uiStructure.pattern"
      [attr.title]="uiStructure['title']"
      [attr.disabled]="uiStructure.disabled ? 'disabled' : null"
      [rows]="uiStructure.rows"
      #thisElement
      axis-input-clear
      axis-autosize
      [ngClass]="uiStructure.componentHostClasses"
      class="axis-form-control"
    >
    </textarea>
  </ng-template>

  @if (uiStructure.fieldMenu) {
  @for (item of uiStructure.fieldMenu; track item) {
  <label-menu
    [item]="item"
    (labelMenuIconEvent)="labelMenuIconEvent($event)"
  ></label-menu>
  }
  }

  @if (uiStructure.helpText && uiStructure.helpText.length > 0) {
  <span
    class="axis-help-block"
    role="region"
    id="{{id + '-help'}}"
  >
    {{uiStructure.helpText}}
  </span>
  }

  @if (thisField?.invalid && (thisField?.touched || errorMessages.getTriedToSubmit(uiStructure.AUGinstance))) {
  @if (uiStructure.required &&
  (thisField?.value === null ||
  !thisField?.value ||
  (thisField?.value && thisField?.value.length <
    1)))
    {
    <span
    class="axis-error-block"
    aria-live="assertive"
    id="{{errorId}}"
  >
    {{errors['required'] || errorMessages['Errors']['required']}}
    </span>
    }
    @if (uiStructure.minLength &&
    thisField?.value &&
    thisField?.value.length <
      uiStructure.minLength)
      {
      <span
      class="axis-error-block"
      aria-live="assertive"
      id="{{errorId}}"
    >
      {{errors['minlength'] || errorMessages['Errors'].minlength}}
      </span>
      }
      @if (uiStructure.maxLength &&
      thisField?.value &&
      thisField?.value.length > uiStructure.maxLength) {
      <span
        class="axis-error-block"
        aria-live="assertive"
        id="{{errorId}}"
      >
        {{errors['maxlength'] || errorMessages['Errors'].maxlength}}
      </span>
      }
      @if (uiStructure.pattern && thisField?.errors && thisField?.errors['pattern']) {
      <span
        class="axis-error-block"
        aria-live="assertive"
        id="{{errorId}}"
      >
        {{errors['pattern'] || errorMessages['Errors'].pattern}}
      </span>
      }
      <!-- custom error message set by application. -->
      @if (thisField?.errors && thisField?.errors['custom']) {
      <span
        class="axis-error-block"
        aria-live="assertive"
        id="{{errorId}}"
      >
        {{thisField?.errors['custom'].errorMessage}}
      </span>
      }
      }
</div>
}